<template>
  <card>
    <div class="container">
      <div style="margin: 10px 10px 10px 10px;">
        <el-row>
          <!-- <el-col :span="18">
          <el-button type="warning">新增商店</el-button>
          </el-col>-->
          <el-col :xs="12" :span="6">
            <el-input
              placeholder="Search"
              v-model="filters[0].value"
            ></el-input>
          </el-col>
        </el-row>
      </div>

      <data-tables
        :data="tableData"
        :pagination-props="paginationProps"
        :filters="filters"
        :table-props="tableProps"
      >
        <el-table-column
          label="商店ID"
          prop="accountId"
          sortable="custom"
          min-width="20px"
        >
          <template slot-scope="scope">{{ scope.row.accountId }}</template>
        </el-table-column>
        <el-table-column
          label="商店名稱"
          prop="name"
          sortable="custom"
          min-width="30px"
        >
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <!-- <el-table-column label="所屬SI" min-width="30px">
        <template slot-scope="scope">{{scope.row.si}}</template>
        </el-table-column>-->

        <el-table-column label="操作">
          <template slot-scope="scope">
            <div class="row eaa-button-row">
              <div class="col-md-6">
                <n-button
                  type="info btn-round btn-block"
                  :size="btnSize"
                  @click.native="settings(scope.row.businessId)"
                  style="margin: 0 0 10 0;"
                >
                  <i class="now-ui-icons loader_gear"></i>
                  參數設定
                </n-button>
              </div>
              <div class="col-md-6">
                <n-button
                  type="danger btn-round btn-block"
                  :size="btnSize"
                  @click.native="acls(scope.row.accountId)"
                >
                  <i class="now-ui-icons users_circle-08"></i>
                  權限管理
                </n-button>
              </div>
            </div>
            <div class="row eaa-button-row">
              <div class="col-md-6">
                <n-button
                  type="default  btn-round btn-block"
                  :size="btnSize"
                  @click.native="clickQR(scope.row)"
                >
                  <i class="now-ui-icons tech_mobile"></i>
                  產生桌號QR碼
                </n-button>
              </div>

              <div class="col-md-6">
                <n-button
                  type="warning btn-round btn-block"
                  size="btnSize"
                  @click.native="lineNotifySetting(scope.row)"
                >
                  <i class="now-ui-icons ui-1_bell-53"></i>推播群組設定
                </n-button>
              </div>
            </div>

            <div class="row eaa-button-row">
              <!-- <div class="col-md-6">
                <n-button
                  type="success btn-round  btn-block"
                  :size="btnSize"
                  style="background:#A25DDC;"
                  @click.native="openingSetting(scope.row)"
                >
                  <i class="now-ui-icons gestures_tap-01"></i>公休日設定
                </n-button>
              </div> -->
              <div class="col-md-6">
                <n-button
                  type="success btn-round  btn-block"
                  :size="btnSize"
                  @click.native="showQcposUsers(scope.row)"
                >
                  <i class="now-ui-icons gestures_tap-01"></i>接單機使用者管理
                </n-button>
              </div>
              <div class="col-md-6">
                <n-button
                  type="success btn-round  btn-block"
                  :size="btnSize"
                  style="background:#f56042;"
                  @click.native="logisticsConf(scope.row)"
                >
                  <i class="now-ui-icons gestures_tap-01"></i>外送條件設定
                </n-button>
              </div>
            </div>
            <div class="row eaa-button-row">
              <!-- <div class="col-md-6">
                <n-button
                  type="success btn-round  btn-block"
                  :size="btnSize"
                  style="background:#6600cc;"
                  @click.native="orderLimits(scope.row.accountId)"
                >
                  <i class="now-ui-icons gestures_tap-01"></i>訂單限流設定
                </n-button>
              </div> -->
            </div>
          
          </template>
        </el-table-column>
      </data-tables>

      <el-dialog
        :title="'接單機使用者管理｜' + dialogs.qcposUsers.shop.name"
        :width="dialogs.qcposUsers.width"
        :visible.sync="dialogs.qcposUsers.show"
      >
        <PosUserMngmt
          user-type="eaa"
          :shop-id="dialogs.qcposUsers.shop.accountId"
        />
      </el-dialog>
    </div>
  </card>
</template>

<script>
import { Table, TableColumn, Select } from "element-ui";
import PosUserMngmt from "src/pages/QcPos/PosUserMngmt";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
library.add(faQrcode);

import { DataTables, DataTablesServer } from "vue-data-tables";
import { fetchShops } from "../../../javascripts/eaa/fetchData";
import axios from "axios";

// function fetchData() {
//   var config = {
//       method: "get",
//       url: "http://localhost:7654/line/system/businesses/all"
//   };
//   return axios(config);
// }
export default {
  components: {
    // [Table.name]: Table,
    // [TableColumn.name]: TableColumn,
    "font-awesome-icon": FontAwesomeIcon,
    DataTables,
    DataTablesServer,
    PosUserMngmt,
    [Select.name]: Select
  },
  beforeRouteEnter(to, from, next) {
    fetchShops()
      .then(res => {
        console.log("res: ", res.data);
        next(vm => vm.setData(res.data));
      })
      .catch(err => {
        console.log("err: ", err);
      });
  },
  data() {
    return {
      window: {
        width: 0,
        height: 0
      },
      btnSize: "sm",
      paginationProps: {
        pageSizes: [10, 15, 20]
      },
      tableData: [
        // {
        //   accountId: 1,
        //   name: "快意點點點",
        //   si: "IIOT"
        // }
      ],
      filters: [
        {
          prop: ["accountId", "name"],
          value: ""
        }
      ],
      tableProps: {
        defaultSort: {
          prop: "accountId",
          order: "descending"
        }
      },

      dialogs: {
        qcposUsers: {
          width: "30%",
          show: false,
          shop: { id: -1, name: "" }
        }
      }
    };
  },
  created() {
    window.addEventListener('resize', this.handleResize);
      this.handleResize();
  },
  destroyed() {
      window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;
      if (this.window.width <= 767) {
        this.paginationProps = {
          pageSizes: [10, 15, 20],
          layout: "total,jumper,prev, pager, next"
        };
        this.btnSize = 'xs';
        this.dialogs.qcposUsers.width = "90%";
      }else{
        this.paginationProps = {
          pageSizes: [10, 15, 20],
          layout: "total,jumper,prev, pager, next, sizes"
        };
        this.btnSize = 'sm';
        this.dialogs.qcposUsers.width = "50vw";
      }
    },
    setData(data) {
      let shops = data.shops;
      this.tableData.splice(0, this.tableData.length);
      if (shops.length > 0) {
        shops.forEach((shop, index) => {
          let obj = Object.assign({}, { ...shop });
          this.$set(this.tableData, index, obj);
        });
      }
      console.log("this.tableData: ", this.tableData);
    },
    // management() {
    //   this.$router.push({ path: `/eaa/1/management` });
    // },
    settings(businessId) {
      this.$router.push({ path: `/eaa/business/${businessId}/settings` });
    },
    // products() {
    //   this.$router.push({ path: `/eaa/1/products` });
    // },
    // orders() {
    //   this.$router.push({ path: `/eaa/1/orders` });
    // },
    acls(accountId) {
      this.$router.push({ path: `/eaa/business/${accountId}/acls` });
    },

    orderLimits(accountId) {
      this.$router.push({ path: `/eaa/business/${accountId}/order-limits` });
    },
    // reports() {
    //   this.$router.push({ path: `/eaa/1/reports` });
    // },
    // contracts() {
    //   this.$router.push({ path: `/eaa/1/contracts` });
    // }
    clickQR: function(row) {
      console.log("clickQR: ", row);
      this.$router.push({ path: `/eaa/business/${row.businessId}/qr` });
    },
    lineNotifySetting: function(row) {
      // console.log('the row ', row);
      // 店家操作的不需要輸入名稱跟網址
      this.$router.push({
        path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${
          row.name
        }`
      });
    },
    openingSetting: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      this.$router.push({
        path: `/opening?${qs}`
        // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      });
    },
    logisticsConf: function(row) {
      let qs = `shop_id=${row.accountId}&shop_name=${encodeURIComponent(
        row.name
      )}`;
      // this.$router.push({
      //   path: `/logistics?${qs}`
      //   // path: `/line-notify-groups?shop_id=${row.accountId}&shop_name=${row.name}`
      // });
      let routeUrl = this.$router.resolve({ path: `/logistics?${qs}`}); 
      window.open(routeUrl.href, '_blank'); 
    },
    showQcposUsers(row) {
      console.log("showQcposUsers", row);
      this.dialogs.qcposUsers.show = true;
      this.dialogs.qcposUsers.shop = row;
    }
  }
};
</script>
<style scoped>
.eaa-button-row {
  margin: 0 0 10px 0;
}
@media only screen and (max-width: 767px) {
  .eaa-button-row {
    margin: auto;
  }
}
@media only screen and (max-width: 767px) {
  .hidden-xs-only {
    display: none !important;
  }
}
</style>
